import {
  CloudDownloadOutlined,
  DeleteFilled,
  UndoOutlined,
} from "@ant-design/icons";
import { Button, Card, Popconfirm } from "antd";
import { clsx } from "clsx";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { downloadAttachment, getImageByUrl } from "../../Common";
import { ReactComponent as FolderIcon } from "../../assets/svg/folder-icon.svg";
import { deleteFile, getDirectory, getFiles } from "../../redux/action/file";
import {
  downloadAndDecryptFile,
  formatDateToYYYYMMDD,
  formatFileSize,
} from "../../utils/common";
import { useSelector } from "react-redux";
import { debugLog } from "../../utils/debugLog";
import { handleDeleteRequest, handlePostRequest } from "../../redux/action";
import emptyImage from "../../assets/svg/emptyImage.png";
import DeleteFilesDialog from "../DeleteFilesDialog";
import { useTranslation } from "react-i18next";
import CustomModal from "../CustomModal";

const TrashCard = ({
  name,
  isSub = false,
  icon = true,
  isNav = false,
  directory,
  thumbnailUrl,
  isHeader = false,
  actualImage,
  ext,
  fileId,
  fetchBinData,
  fileSize,
  fileDate,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRestoreModal, setshowRestoreModal] = useState(false);

  const { encryptionKeys } = useSelector((state) => state.authSlice);
  const { Date, ivKey, spaceKey } = encryptionKeys ?? {};
  const key = spaceKey;
  const iv = ivKey;
  const date = Date;
  const navigate = useNavigate();
  const location = useLocation();
  const [thumbnail, setThumbnail] = useState("");

  const cardStyle = {
    background: "$primary-color",
    background: `url(${thumbnail})`,
  };
  debugLog("🚀 ~ thumbnail:", "log", thumbnailUrl);

  useEffect(() => {
    const getThumb = async () => {
      const res = await getImageByUrl(thumbnailUrl);
      setThumbnail(res);
    };
    if (isSub) getThumb();
  }, []);

  const handleDownloadAttachment = async (e) => {
    e.stopPropagation();
    const res = await getImageByUrl(actualImage);
    if (res) downloadAttachment(res, name, ext);
  };

  // Delete functions
  const handleDeleteClick = (e) => {
    e.stopPropagation();
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    const file = [];
    file.push(fileId);
    await handleDeleteRequest("/hard-delete-file", file);
    fetchBinData();
    setShowDeleteModal(false);
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };

  const restoreFile = async (e, fileId) => {
    const file = [];
    file.push(fileId);
    await handlePostRequest("/restore-file", file);
    fetchBinData();
  };
  const { t } = useTranslation();
  return (
    <div className={clsx("file-card", name)}>
      <Card
        bordered={false}
        // onClick={() => handleClick(name)}
        className="card-container"
        bodyStyle={isNav ? {} : { padding: 0 }}
      >
        <>
          <div className="file-thumbnail" style={{ height: 154 }}>
            {thumbnail ? (
              <img
                src={thumbnail}
                alt={name}
                width={140}
                height={154}
                style={{
                  width: "100%",
                  objectFit: "cover",
                  borderTopLeftRadius: "19px",
                  borderTopRightRadius: "19px",
                }}
              />
            ) : (
              <img
                src={""}
                alt="No preview"
                style={{
                  height: "60px",
                  opacity: 0.3,
                }}
              />
            )}
          </div>

          {/* Bottom Half - File info + buttons */}
          <div className="file-info-panel">
            <div className="file-name" title={name}>
              {name}
            </div>
            <div className="file-meta">{formatFileSize(fileSize) || "-"}</div>
            <div className="file-date">
              <span>Deleted at:</span> {formatDateToYYYYMMDD(fileDate) || "-"}
            </div>
            <div className="file-actions">
              <Button
                size="small"
                // danger
                onClick={() => setshowRestoreModal(true)}
                type="primary"
                className="custom-download-btn responsive-btn"
                style={{
                  borderRadius: 30,
                  fontSize: "clamp(10px, 2.5vw, 14px)",
                  padding: "4px 8px",
                  minWidth: "70px",
                  height: "auto",
                }}
              >
                {t("common.restore")}
              </Button>

              <Button
                size="small"
                type="primary"
                danger
                className="custom-download-btn responsive-btn"
                style={{
                  fontSize: "clamp(10px, 2.5vw, 14px)",
                  padding: "4px 8px",
                  minWidth: "70px",
                  height: "auto",
                }}
                onClick={handleDeleteClick}
              >
                {t("common.delete")}
              </Button>
            </div>
          </div>
          <DeleteFilesDialog
            visible={showDeleteModal}
            onDelete={handleConfirmDelete}
            onCancel={handleCancelDelete}
          />
          {showRestoreModal && (
            <CustomModal
              title={
                <span>
                  {t("common.restore")} {t("label.files")}
                </span>
              }
              visible={showRestoreModal}
              className="my-custom-modal"
              handleCancel={() => setshowRestoreModal(false)}
              // handleOk={handleDeleteUser}
              width={400}
              footer={false}
            >
              <span className="font-color">{t("messages.confirmRestore")}</span>
              <div className="figma-modal-footer">
                <Button
                  onClick={() => setshowRestoreModal(false)}
                  className="figma-cancel-btn"
                >
                  {t("common.cancel")}
                </Button>

                <Button
                  type="primary"
                  onClick={(e) => restoreFile(e, fileId)}
                  className="figma-delete-btn"
                >
                  {t("common.restore")}
                </Button>
              </div>
            </CustomModal>
          )}
        </>
      </Card>
    </div>
  );
};

export default TrashCard;
